React = require 'react'
{ Component, PropTypes } = React
LoginComponent = require '../components/Login'
{ connect } = require 'react-redux'
{ login, redirectAfterLogin } = require '../actions/auth'

localStorageWorks = false
try
	localStorage.setItem 'localStorageWorks', true
	localStorageWorks = true
	localStorageWorks.removeItem 'localStorageWorks'
catch e

mapStateToProps = (state) ->
	isAuthenticated: state.auth.isAuthenticated
	errorMessage: state.auth.errorMessage
	loginPrompt: state.auth.loginPrompt
	localStorageWorks: localStorageWorks

mapDispatchToProps = {
	onLogin: login
	redirectAfterLogin
}

module.exports = connect(mapStateToProps, mapDispatchToProps) LoginComponent



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/Login.cjsx